// src/index.js

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './global.css'; // Seus estilos globais
import App from './App';
import './i18n'; // Adicionar esta linha para inicializar o i18next
import DNALoadingAnimation from './components/DNALoadingAnimation';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.Suspense fallback={<DNALoadingAnimation />}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.Suspense>
);
